module.exports = __webpack_public_path__ + "static/media/violet@2x.5339b13b.png";